const browserError = `<h1>Oops...</h1>
<h2>This browser is not supported.</h2>
<h3 style="text-align: center;">But don’t worry, there is an easy fix. All you have to do is to click on one of the icons below and follow the instructions.</h3>
<h2 class="bottom"><a title="Use Safari" class="browser-icon browser-safari" href="http://www.apple.com/safari/"></a>&nbsp;&nbsp;<a title="Download Firefox" class="browser-icon browser-firefox" href="https://www.mozilla.org/firefox"></a>&nbsp;&nbsp;<a title="Download Chrome" class="browser-icon browser-chrome" href="https://www.google.com/chrome"></a></h2>`;

module.exports = function () {
  if (!isValidBrowser()) { throw new Error(browserError); }
};

function isValidBrowser () {
  const navAgent = navigator.userAgent;

  if (navAgent.includes('Firefox') ||
    navAgent.includes('Chrome') ||
    navAgent.includes('Safari') ||
    navAgent.includes('AppleWebKit')) {
    return true;
  }
}
